import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline-flex',
    width: '300px',
    flexDirection: 'column',
    borderRadius: '8px',
    backgroundColor: theme.palette.common.white,
    boxShadow: '0px 4px 36px rgba(0, 10, 22, 0.13)',
  },
  card: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    textAlign: 'center',
    borderRadius: '9px',
    paddingTop: '2rem',
    margin: '0 0 1.5rem 0',
    boxShadow: '0px 4px 12px rgba(0, 10, 22, 0.13)',
    height: '376px',
    width: '300px',
    cursor: 'pointer',
  },
  soloCard: {
    width: '550px',
  },
  hopeCard: {
    height: '232px',
    cursor: 'default',
  },
  avatar: {
    height: '100px',
    width: '100px',
    color: theme.palette.primary.contrastText,
    fontWeight: 700,
    fontSize: '2rem',
    background: '#BDBDBD',
  },
  title: {
    color: theme.palette.primary.dark,
    fontWeight: 700,
    lineHeight: '20px',
    marginTop: '0.625rem',
  },
  bioContainer: {
    height: '5rem',
    overflow: 'hidden',
    marginTop: '1rem',
  },
  bio: {
    lineHeight: '1.375rem',
  },
  button: {
    marginBottom: '1rem',
  },
}))

export default useStyles
